<template>
    <div>

      <select name="lieu" id="lieu" v-model="lieu">
        <option value="">
          Veuillez choisir le lieu de votre disponibilité
        </option>
        <template v-for="l in lieuxDispo" :key="l.id">
          <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
        </template>
      </select>
      <div class="calendar-container">
        <FullCalendar ref="fullCalendar" :options="calendarOptions" />
      </div>

    </div>
  </template>
  
  <script>
  import "@fullcalendar/core/vdom";
  import FullCalendar from "@fullcalendar/vue3";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import timeGridPlugin from "@fullcalendar/timegrid";
  import interactionPlugin from "@fullcalendar/interaction";
  import moment from "moment";
  
  export default {

    props: [
      "eleve",
      "getAllEleves",
      "dispoIsUpdate"
    ],
  
    components: {
      FullCalendar,
    },
  
    data() {
      return {
        loadDispoEleveBtn : false,
        lieuxDispo: [],
        lieu : "",
        showDispoMod : false,
        planningSelect : "",
        calendarOptions: {
          plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
          initialView: "timeGridWeek",
          nowIndicator: true,
          eventResizableFromStart: true,
          firstDay: 1,
          allDaySlot: false,
          slotMinTime: "07:00:00",
          slotMaxTime: "21:00:00",
          height: "auto",
          locale: "fr",
          selectable: true,
          timeZone: "local",
          eventClick: this.deleteEvent,
          headerToolbar: {
            start: "prev,next",
            center: "title",
            end: "timeGridWeek,timeGridDay",
          },  
          events: [],
          select: this.select,
          editable: true,
          selectAllow: this.selectAllow,
          eventChange: this.putDispoEleve,
          newDispo : false,
        },
      };
    },

    mounted() {
      this.getLieuxEleve();
      if(this.$store.state.rdvBoite != null){
        this.calendarOptions.events = this.$store.state.rdvBoite;
      }
  
      if(this.moniteurEdits == null){
        this.calendarOptions.events = [];
      }
      this.eleve.dispos.forEach(d => {
        this.calendarOptions.events.push({
            id: d.id,
            title: "Dispo : "+d.lieu,
            start: moment(d.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(d.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            recurring: "true",
            color: "blue",
            type: "dispo",
        });
      })
      
    },
  
    methods: {

      refreshCalendar() {
        const api = this.$refs.fullCalendar.getApi();
        if (api) {
          api.updateSize()
        }
      },

      getLieuxEleve() {
        window.api
          .get("/eleve/lieux/" + this.eleve.id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            response.data.lieux.forEach(l => {
              let findL = null;
              findL = this.lieuxDispo.find(e => e.id == l.id)
              if(findL == undefined){
                this.lieuxDispo.push(l);
              }
            })
          })
          .catch((error) => {
            console.log(error);
          });
      },

  
      deleteEvent(e){
        window.api
        .delete("/disponibilites/" + e.event["_def"].publicId, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          let events = [];
          this.calendarOptions.events.forEach(i => {
            if(i.id != e["event"]["_def"]["publicId"]){
              events.push(i);
            }
          })
          this.calendarOptions.events = events;
          this.$emit("getAllEleves");
        })
        .catch((error) => {
          console.log(error);
        });
      },
  
      select(e) {
        this.planningSelect = e;
        //this.showDispoMod = true;
        this.setDispo();
      },

      putDispoEleve(arg) {
        if (arg.event["_def"].title.substring(0, 5) == "Dispo") {
          window.api
            .put(
              "/disponibilites/" + arg.event._def.publicId,
              {
                start: arg.event._instance.range.start,
                end: arg.event._instance.range.end,
                eleve: "api/utilisateurs/" + this.eleve.id,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              },
            )
            .then(() => {
              this.$emit("getAllEleves");
              // Même souci de mesure de taille FullCalendar dans ce dialog qu'à l'ouverture
              // (cf. onDialogShow côté Header.vue) : sans ça, le bloc déplacé peut se superposer
              // visuellement à un autre événement du même créneau.
              this.refreshCalendar();
            })
            .catch((error) => {
              console.log(error);
              arg.revert();
            });
        }
      },

      setDispo(){
        this.loadDispoEleveBtn = true;
        if(this.lieu == ""){
          alert("Veuillez saisir un lieu pour votre disponibilité");
          this.loadDispoEleveBtn = false;
        }else{
          window.api
          .post(
            "/disponibilites",
            {
              start: moment(this.planningSelect.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningSelect.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              eleve: "api/utilisateurs/" + this.eleve.id,
              lieu: "api/lieus/" + this.lieu,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.$emit("dispoIsUpdate", true);
            let lieuNom = "";
            this.lieuxDispo.forEach(l => {
              if(l.id == this.lieu){
                lieuNom = l.nom;
              }
            })

            this.calendarOptions.events.push({
              id: response.data.id,
              title: "Dispo : "+ lieuNom,
              start: moment(this.planningSelect.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningSelect.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              recurring: "true",
              color: "blue",
              type: "dispo",
          });
          this.$emit("getAllEleves");
          this.showDispoMod = false;
          this.loadDispoEleveBtn = false;
          })
          .catch((error) => {
            console.log(error);
          });
        }
      }

    },
  };
  </script>

<style scoped>

div.calendar-container{
    width: 100%;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

select{
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  background: #fff;
  color: #1a1f2e;
  outline: none;
  margin-bottom: 1rem;
}

/* Fond jaune pour le jour actuel */
:deep(.fc-day-today) {
  background-color: #fffde7 !important;
}

/* En-têtes des colonnes de jours */
:deep(.fc-col-header-cell) {
  padding: 8px 0;
  font-size: 13px;
}

:deep(.fc-col-header-cell-cushion) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  text-transform: capitalize;
}

/* Jour actuel : numéro en badge bleu */
:deep(.fc-day-today .fc-col-header-cell-cushion) {
  color: #1a73e8;
}

/* Style des événements */
:deep(.fc-event) {
  border-radius: 6px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  padding: 2px 6px !important;
  box-shadow: none !important;
}

:deep(.fc-event-time) {
  font-size: 10px;
  display: block;
}

:deep(.fc-event-title) {
  font-weight: 600;
  display: block;
}

/* Grille générale */
:deep(.fc-timegrid-slot) {
  height: 40px;
}

:deep(.fc-timegrid-slot-label) {
  font-size: 12px;
  color: #888;
}

/* Suppression de la bordure trop marquée */
:deep(.fc-scrollgrid) {
  border-color: #e0e0e0 !important;
}

:deep(.fc-scrollgrid td),
:deep(.fc-scrollgrid th) {
  border-color: #e0e0e0 !important;
}

/* Toolbar générale */
:deep(.fc-toolbar) {
  padding: 8px 12px;
}

/* Suppression du style par défaut des groupes de boutons */
:deep(.fc-button-group),
:deep(.fc-button) {
  box-shadow: none !important;
  outline: none !important;
}

/* Boutons navigation (< >) */
:deep(.fc-prev-button),
:deep(.fc-next-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 50% !important;
  color: #555 !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.fc-prev-button:hover),
:deep(.fc-next-button:hover) {
  background-color: #f1f3f4 !important;
}

/* Bouton Aujourd'hui */
:deep(.fc-today-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 4px 14px !important;
  text-transform: capitalize !important;
}

:deep(.fc-today-button:hover) {
  background-color: #f1f3f4 !important;
}

:deep(.fc-today-button:disabled) {
  opacity: 0.5 !important;
}

/* Boutons Semaine / Jour / Dimanche */
:deep(.fc-timeGridWeek-button),
:deep(.fc-timeGridDay-button),
:deep(.fc-hideSunday-button) {
  background-color: transparent !important;
  border: none !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 4px 14px !important;
}

:deep(.fc-timeGridWeek-button:hover),
:deep(.fc-timeGridDay-button:hover),
:deep(.fc-hideSunday-button:hover) {
  background-color: #f1f3f4 !important;
}

/* Bouton actif */
:deep(.fc-timeGridWeek-button.fc-button-active),
:deep(.fc-timeGridDay-button.fc-button-active),
:deep(.fc-hideSunday-button.fc-button-active) {
  background-color: #e8f0fe !important;
  border-color: #e8f0fe !important;
  color: #1a73e8 !important;
}

/* Container groupe de boutons droits */
:deep(.fc-toolbar-chunk:last-child) {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  padding: 2px 4px;
}


</style>
  